import { Box, Typography, Container } from '@mui/material';
import { useState } from 'react';
import SearchBar from './SearchBar';
import UserFilter from './FilterUser';
import DateRangePicker from './DateRangePicket';
import LikeRangeSlider from './LikeRangeSlider';
import CommentsRangeSlider from './CommentsRangeSlide';
import RepostsRangeSlider from './RepostsRangeSlider';
import PostTypeSelector from './PostTypeSelector';
import FormatingTypeSelector from './FormatingTypeSelector';
import FilterCards from './FilterCards';
import PostsFeed from './Feeds';



export const MAX_REPOSTS = 500;
export const MAX_COMMENTS = 10000;
export const MAX_LIKES = 10000;

function PostsAndSearch() {
  const [searchParams, setSearchParams] = useState({
    query: '',
    minReposts: 1,
    maxReposts: 20,
    startDate: '2025-01-01T00:00:00',
    endDate: '2025-02-01T23:59:59',
    postTypes: ['image', 'text', 'carousel', 'video'],
    userIds: [],
  });
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null
  });
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [likesRange, setLikesRange] = useState([1, MAX_LIKES]);
  const [commentsRange, setCommentsRange] = useState([1, MAX_COMMENTS]);
  const [repostsRange, setRepostsRange] = useState([1, MAX_REPOSTS]);
  const [postType, setPostType] = useState('All Posts');
  const handleSearch = (params) => {
    let postTypes = [];
    if (postType === 'All Posts') {
      postTypes = ['image', 'text', 'carousel', 'video'];
    } else {
      postTypes = [postType.toLowerCase()];
    }
    setSearchParams((prev) => ({
      ...prev,
      query: params.query,
      minLikes: likesRange[0],
      maxLikes: (likesRange[1] == MAX_LIKES ? 10000 : likesRange[1]),
      minComments: commentsRange[0],
      maxComments: (commentsRange[1] == MAX_COMMENTS ? 10000 : commentsRange[1]),
      userIds: selectedUsers.map((user) => user.id),
      startDate: dateRange?.startDate?.toISOString(),
      endDate: dateRange?.endDate?.toISOString(),
      postTypes: postTypes.join(','),
      minReposts: repostsRange[0],
      maxReposts: (repostsRange[1] == MAX_REPOSTS ? 1000 : repostsRange[1]),
    }));
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, width: '100%', maxWidth:'95%', gap: '16px',margin:'16px 0px' }}>
      <Box sx={{ flex: '0 0 75%'}}>
        {/* <Container sx={{  padding: 2}}>
          <FilterCards />
        </Container> */}
        <Container sx={{  padding: 2}}>
          <PostsFeed searchParams={searchParams}/>
        </Container>
      </Box>

      <Box sx={{ flex: '0 0 25%' }}>
        <Container sx={{  padding: 2, border: '1px solid #f2f2f2', borderRadius: '12px'}}>
          <SearchBar onSearch={handleSearch} />
        </Container>
        <Container sx={{  padding: '0px !important', border: '1px solid #f2f2f2', borderRadius: '12px',marginTop:'16px'}}>
          <div style={{ padding: '20px' }}>
            <Typography variant="h6" sx={{fontSize:'16px',fontWeight:600,color:'#7d7c7c'}}>Filter by user</Typography>
            <UserFilter selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers}/>
          </div>
          <div style={{ padding: '20px' , borderTop:'1px solid #f2f2f2' }}>
            <Typography variant="h6" sx={{fontSize:'16px',fontWeight:600,color:'#7d7c7c'}}>Date range</Typography>
            <DateRangePicker dateRange={dateRange} setDateRange={setDateRange}/>
          </div>
          <div style={{ padding: '20px' , borderTop:'1px solid #f2f2f2' }}>
            <Typography variant="h6" sx={{fontSize:'16px',fontWeight:600,color:'#7d7c7c'}}>Likes range</Typography>
            <LikeRangeSlider value={likesRange} setValue={setLikesRange}/>
          </div>
          <div style={{ padding: '20px' , borderTop:'1px solid #f2f2f2' }}>
            <Typography variant="h6" sx={{fontSize:'16px',fontWeight:600,color:'#7d7c7c'}}>Comments range</Typography>
            <CommentsRangeSlider value={commentsRange} setValue={setCommentsRange}/>
          </div>
          <div style={{ padding: '20px' , borderTop:'1px solid #f2f2f2' }}>
            <Typography variant="h6" sx={{fontSize:'16px',fontWeight:600,color:'#7d7c7c'}}>Reposts range</Typography>
            <RepostsRangeSlider repostsRange={repostsRange} setRepostsRange={setRepostsRange}/>
          </div>
          <div style={{ padding: '20px' , borderTop:'1px solid #f2f2f2' }}>
            <Typography variant="h6" sx={{fontSize:'16px',fontWeight:600,color:'#7d7c7c'}}>Post type</Typography>
            <PostTypeSelector postType={postType} setPostType={setPostType}/>
          </div>
          <div style={{ padding: '20px' , borderTop:'1px solid #f2f2f2' }}>
            <Typography variant="h6" sx={{fontSize:'16px',fontWeight:600,color:'#7d7c7c'}}>Formating type</Typography>
            <FormatingTypeSelector/>
          </div>
        </Container>
      </Box>
    </Box>
  );
}

export default PostsAndSearch;